import { render, staticRenderFns } from "./EnvolvimentoTerceiros.vue?vue&type=template&id=2256a673&scoped=true"
import script from "./EnvolvimentoTerceiros.vue?vue&type=script&lang=js"
export * from "./EnvolvimentoTerceiros.vue?vue&type=script&lang=js"
import style0 from "./EnvolvimentoTerceiros.vue?vue&type=style&index=0&id=2256a673&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256a673",
  null
  
)

export default component.exports